export default {
    general: {
        show_password: 'Show password',
        hide_password: 'Hide password',
        add: 'Add',
        edit: 'Edit',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        search: 'Search',
        close: 'Close',
        confirm: 'Confirm',
        back: 'Back',
        actions: 'Actions',
        yes: 'Yes',
        no: 'No',
        loading: 'Loading …',
        select: 'Select',
        preview: 'Preview',
        download: 'Download',
    },
    errors: {
        generic_error: 'An error occurred',
        load_data: 'Failed to load data',
        on_add: 'Failed to add',
        on_edit: 'Failed to save changes',
        on_delete: 'Failed to delete',
        on_sort: 'Failed to reorder',
        on_logout: 'Failed to log out',
        no_access: 'You do not have access',
    },
    api_errors: {
        internal_server_error: 'Unknown internal server error',
        invalid_data: 'Invalid data received',
        not_found: 'Not found',
        unauthorized: 'You are not allowed to do that',
        invalid_password: 'Incorrect password',
        invalid_email: 'Invalid e-mail address',
        invalid_email_or_password: 'Incorrect e-mail or password',
        invalid_file_type: 'Unsupported document format',
        invalid_captcha: 'Invalid captcha',
        forgotten_password_expired: 'The password reset request has expired',
        invalid_bill_password: 'Invalid bill password',
        user_exists_by_email: 'A user with this e-mail already exists',
        user_exists_by_code_payer: 'A user with this payer code already exists',
        no_code_payer: 'The payer code does not exist',
        manager_missing: 'Manager data is missing',
        user_not_connected_to_manager: 'The user is not connected to a manager',
    },
    success: {
        add: 'Added successfully',
        edit: 'Saved successfully',
        delete: 'Deleted successfully',
        sort: 'Reordered successfully',
    },
    confirm: {
        default: 'Are you sure you want to continue?',
        delete_row: 'Are you sure you want to delete {name}',
    },
    validation: {
        required: 'This field is required',
        email: 'Invalid e-mail address',
        min_length: 'Enter at least {min} characters',
        at_least_one_uppercase: 'The password must contain at least one uppercase letter',
        at_least_one_digit: 'The password must contain at least one digit',
        passwords_must_match: 'Passwords do not match',
    },
    navigation: {
        menu: 'Menu',
        users: 'Users',
        partners: 'Partners',
        depositories: 'Depositories',
        bulletin_board: 'Bulletin board',
        faq: 'FAQ',
        allowed_pages: 'Allowed pages',
        change_password: 'Change password',
        logout: 'Log out',
    },
    footer: {
        all_rights_reserved: 'All rights reserved',
    },
    manager: {
        label: 'Manager',
        search: 'Search managers …',
        no_results: 'No results',
        switch_success: 'Manager switched successfully',
        switch_error: 'Failed to switch manager',
    },
    table: {
        empty: 'No data to display',
        reload: 'Reload',
        clear_filters: 'Clear filters',
        search_by: 'Search by {field}',
        pick_option: 'Pick an option',
        pick_date: 'Pick a date',
        page_report: '{first} - {last} of {total}',
    },
    editor: {
        images_not_allowed: 'Inserting images is not allowed!',
        audio_not_allowed: 'Inserting audio is not allowed!',
        video_not_allowed: 'Inserting video is not allowed!',
    },
    upload: {
        file: 'File',
        files_and_photos: 'Files and photos',
        drop_hint: 'Drag and drop files to upload.',
        uploaded: 'Uploaded',
        type_not_allowed: 'Some files were not added because their format is not allowed',
        clear: 'Remove',
    },
    login: {
        email: 'E-mail',
        password: 'Password',
        remember_me: 'Remember me',
        forgotten_password: 'Forgot your password?',
        submit: 'Sign in',
        error: 'Sign-in failed',
    },
    change_password: {
        title: 'Change password',
        current: 'Current password',
        new: 'New password',
        repeat: 'Confirm password',
        submit: 'Change password',
        success: 'Password changed successfully',
        error: 'Failed to change the password',
    },
    forgotten_password: {
        title: 'Forgotten password',
        intro: 'Enter your e-mail address below and we will send you instructions to reset your password.',
        submit: 'Reset password',
        sent_title: 'Password reset instructions sent!',
        sent_body: 'Instructions on how to reset your password were sent to the e-mail address you entered. The password must be reset within 24 hours.',
        back_to_login: 'Back to sign in',
        captcha_error: 'The captcha could not be solved. Please refresh the page.',
        send_error: 'Failed to send the e-mail',
    },
    reset_password: {
        title: 'Reset your password',
        intro: 'Enter your new password below.',
        new: 'New password',
        repeat: 'Repeat password',
        submit: 'Reset password',
        success: 'Your password was reset successfully!',
        error: 'Failed to reset the password',
    },
    not_found: {
        title: 'Page not found!',
        subtitle: 'We could not find the page you were looking for.',
        back_home: 'Back to the home page',
    },
    user: {
        title: 'Users',
        add: 'Add user',
        firstname: 'First name',
        lastname: 'Last name',
        email: 'E-mail',
        code_payer: 'Payer code',
        address: 'Address',
        post_code: 'Post code',
        city: 'City',
        post_and_city: 'Post code and city',
        password: 'Password',
        password_help: 'The password must be at least 8 characters long and contain at least one uppercase letter and one digit.',
        bill_password: 'Bill password',
        bill_password_help: 'You can find the password on your bill.',
        generate: 'Generate',
        check_email: 'Check the user e-mail',
        enter_valid_email: 'Enter a valid e-mail address',
        change_password: 'Change password',
        change_user_password: 'Change the user password',
        switch_to: 'Switch',
        switch_error: 'Failed to switch to the user',
        export: 'Export users',
        export_error: 'Failed to export the users',
        unlink: 'Unlink',
        unlink_confirm: 'Are you sure you want to unlink the user: {firstname} {lastname} - {code_payer}?',
        unlink_success: 'The user was unlinked successfully',
        unlink_error: 'Failed to unlink the user',
    },
    partner: {
        title: 'Partners',
        name: 'Name',
        code: 'Code',
        address: 'Address',
        post_code: 'Post code',
        city: 'City',
        password: 'Password',
        password_set: 'Password is set',
        password_not_set: 'Password is not set',
        switch_to: 'Switch',
        switch_error: 'Failed to switch to the partner',
    },
    depository: {
        title: 'Depositories',
        add: 'Add depository',
        base: 'Base depository',
        display_name: 'Display name',
        content: 'Depository content',
        content_of: 'Depository content: {name}',
        delete_name: 'depository: {name}?',
        filter_by_building: 'Filter by building',
        document_name: 'Name',
        subject: 'Subject',
        partner: 'Partner',
        document_date: 'Document date',
        format: 'Format',
        no_file: 'The document has no file',
        download_error: 'Failed to download the document',
    },
    bulletin: {
        title: 'Bulletin board',
        add: 'Add notice',
        edit: 'Edit notice',
        name: 'Title',
        content: 'Content',
        buildings: 'Buildings',
        pick_buildings: 'Pick buildings',
        limit_to_buildings: 'Limit to buildings',
        limited_to_building: 'Limited to building',
        active: 'Active notice',
        delete_name: 'notice: {title}?',
    },
    faq: {
        title: 'FAQ',
        add: 'Add question',
        position: 'Order',
        question: 'Question',
        answer: 'Answer',
        delete_name: 'question: {question}?',
    },
    allowed_pages: {
        title: 'Allowed pages',
        page_name: 'Page name',
        pages: {
            regular_billing: 'Regular billing',
            reserve_fund_billing: 'Reserve fund billing',
            open_items: 'Open items',
            card_traffic: 'Billing and payments card',
            readings: 'Heat billing',
            reserve_fund: 'Reserve fund',
            voluntary_fund: 'Voluntary fund',
            reserved_fund_debtors: 'Reserve fund debtors',
            reserved_fund_postings: 'Reserve fund postings',
            manager_documents: 'Manager documents',
            supplier_documents: 'Supplier documents',
            notifications: 'Notifications',
            your_units: 'Your units',
            bulletin_board: 'Bulletin board',
            faq: 'FAQ',
            contractors: 'Contractors',
            cost_specification: 'Cost specification',
            tenants: 'Tenants',
            registered_people_and_dogs: 'Registered number of people and dogs',
            insurance_contracts: 'Insurance contracts',
        },
    },
}
